import React from 'react';
import { motion } from 'framer-motion';

const Stat = ({ eyebrow, number, line, accent = 'coral', source }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-15%' }}
      transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1] }}
      className="relative py-24 md:py-32 border-b border-white/5 space-y-6"
    >
      {eyebrow && (
        <p className="text-white/50 uppercase font-mono text-xs tracking-[0.35em]">
          {eyebrow}
        </p>
      )}
      <h3
        className={`stat-number ${accent === 'coral' ? 'text-coral' : 'text-teal'}`}
        style={{ fontSize: 'clamp(4rem, 13vw, 13rem)' }}
      >
        {number}
      </h3>
      <p className="editorial-body max-w-2xl">{line}</p>
      {source && (
        <p className="text-mist-500 font-mono text-xs tracking-[0.25em] uppercase">
          Source · {source}
        </p>
      )}
    </motion.div>
  );
};

const Section01Problem = () => {
  return (
    <section id="problem" className="section-pad section-glass">
      <div className="container-edge">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="flex flex-col gap-6 mb-20 md:mb-32 max-w-4xl"
        >
          <h2 className="font-display font-bold text-white leading-[0.95] tracking-tight text-section">
            Piracy isn&rsquo;t a nuisance.<br />
            <span className="text-teal">It&rsquo;s an industry.</span>
          </h2>
          <p className="editorial-body">
            Three numbers tell you everything about how the fight has been going.
          </p>
        </motion.div>

        <div className="space-y-0">
          <Stat
            eyebrow="Revenue"
            number="$28.3B"
            line="Annual sports revenue lost to piracy. And rising every season."
            source="Synamedia / Ampere Analysis, 2024"
          />
          <Stat
            eyebrow="Enforcement"
            number={
              <>
                <span>15M</span>
                <span className="text-white/30"> / </span>
                <span>5%</span>
              </>
            }
            line={
              <>
                <span className="text-white">15&nbsp;million takedown notices</span> sent in&nbsp;2025.
                <br />
                <span className="text-coral font-medium">Five&nbsp;percent</span> of them actually worked.
              </>
            }
            source="MUSO · Friend MTS industry benchmarks"
          />
          <Stat
            eyebrow="Behaviour"
            number="70%"
            line={
              <>
                of American sports fans pirate at least once a month.{' '}
                <span className="text-white">They know it&rsquo;s wrong. They do it anyway.</span>
              </>
            }
            source="Ampere Consumer · Yield Sec, 2025"
          />
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="mt-16 md:mt-24 max-w-3xl text-white/75 editorial-body"
        >
          Streaming scaled the product. It also scaled the leak.
          Every additional distribution path is one more way content walks out the door.
        </motion.p>
      </div>
    </section>
  );
};

export default Section01Problem;
